<script setup>
import { ref, computed } from "vue"
import { Icon, Accordion, Select, Input, ColorPickerDefault } from "@components"
import OptionButton from "./OptionButton.vue"

import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

import { useSettings } from "@store/settings"
const $settings = useSettings()

const activeAccordion = ref('')


const toggleAccordion = (title) => {
    if (activeAccordion.value == title) {
        activeAccordion.value = ''
    } else {
        activeAccordion.value = title
    }
    console.log(title)
    if (title == 'Typography') {
        return router.push({ name: 'customizer.form.overview', query: { ...route.query } })
    } else {
        return router.push({ name: 'customizer.form.account', query: { ...route.query } })
    }
}

const fonts = computed(() => {
    return Object.entries(prebook_admin.options.fonts).map(([key, value]) => {
        return {
            value: key,
            label: `<span style="font-family: '${value}' !important;">${key}</span>`
        }
    })
})
</script>

<template>
    <div>
        <!-- brand color section -->
        <div class="flex justify-between items-center py-2 px-3">
            <div class="flex items-center gap-3">
                <Icon name="palette" size="24px" class="text-[#667085]"></Icon>
                <div class="ml-3 text-[#101828] text-lg font-semibold">Brand Color</div>
            </div>
            <!-- <input type="color" v-model="$settings.customizer.design.brand_color" class="w-6"> -->
            <ColorPickerDefault v-model="$settings.customizer.design.brand_color" class="w-6" />
        </div>

        <div class="h-[1px] bg-[#EAECF0] my-3"></div>

        <!-- corner style section -->
        <div>
            <div class="flex items-center gap-3 py-2 px-3">
                <Icon name="maximize02" size="24px" class="text-[#667085]"></Icon>
                <div class="ml-3 text-[#101828] text-lg font-semibold">Corner Style</div>
            </div>

            <div class="grid grid-cols-2 gap-3 mt-2 mb-[16px]">
                <OptionButton @click="$settings.customizer.design.corner_style = style.name" v-for="style in [{ name: 'Flat', icon: 'flat' }, { name: 'Rounded', icon: 'rounded' }]" :key="style.name" :title="style.name" :icon="style.icon" size="md" :active="$settings.customizer.design.corner_style == style.name" />
            </div>
        </div>

        <div class="transition-all" :class="[activeAccordion == 'Typography' ? 'mt-3' : 'my-3 h-[1px] bg-[#EAECF0]']"></div>

        <!-- typography section -->
        <Accordion leftIcon="type01" title="Typography" :isOpen="activeAccordion == 'Typography'" @click="toggleAccordion('Typography')">
            <div>
                <div class="text-[#101828] font-medium text-sm mb-2">Font Family</div>
                <Select v-model="$settings.customizer.design.font_family" :options="fonts"></Select>
            </div>

            <div>
                <div class="flex items-center justify-between mb-2">
                    <div class="text-[#101828] font-medium text-sm">Title Font</div>
                    <!-- <input v-model="$settings.customizer.design.typography_title_font_color" type="color" class="w-6"> -->
                    <ColorPickerDefault v-model="$settings.customizer.design.typography_title_font_color" class="w-6" />
                </div>

                <div class="grid grid-cols-3 gap-3">
                    <OptionButton @click="$settings.customizer.design.typography_title_font_weight = style.name" v-for="style in [{ name: 'Medium', class: '!font-medium m-auto' }, { name: 'SemiBold', class: '!font-semibold m-auto' }, { name: 'Bold', class: '!font-bold m-auto' }]" :key="style.name" :title="style.name" :icon="style.icon" size="sm" :textClass="style.class" :active="$settings.customizer.design.typography_title_font_weight == style.name" />
                </div>
            </div>

            <div>
                <div class="flex items-center justify-between mb-2">
                    <div class="text-[#101828] font-medium text-sm">Subtitle Font</div>
                    <!-- <input type="color" v-model="$settings.customizer.design.typography_subtitle_font_color" class="w-6"> -->
                    <ColorPickerDefault v-model="$settings.customizer.design.typography_subtitle_font_color" class="w-6" />
                </div>

                <div class="grid grid-cols-3 gap-3">
                    <OptionButton @click="$settings.customizer.design.typography_subtitle_font_weight = style.name" v-for="style in [{ name: 'Regular', class: '!font-normal m-auto' }, { name: 'Medium', class: '!font-medium m-auto' }, { name: 'SemiBold', class: '!font-semibold m-auto' }]" :key="style.name" :title="style.name" :icon="style.icon" size="sm" :textClass="style.class" :active="$settings.customizer.design.typography_subtitle_font_weight == style.name" />
                </div>
            </div>
        </Accordion>

        <div class="transition-all" :class="[activeAccordion == 'Input' ? 'mt-3' : 'my-3 h-[1px] bg-[#EAECF0]']"></div>

        <!-- input section -->
        <Accordion leftIcon="textInput" title="Input" :isOpen="activeAccordion == 'Input'" @click="toggleAccordion('Input')">
            <div>
                <div class="flex items-center justify-between mb-2">
                    <div class="text-[#101828] font-medium text-sm">Input Border</div>
                    <!-- <input type="color" v-model="$settings.customizer.design.input_border_color" class="w-6"> -->
                    <ColorPickerDefault v-model="$settings.customizer.design.input_border_color" class="w-6" />
                </div>

                <div class="grid grid-cols-2 gap-3">
                    <OptionButton @click="$settings.customizer.design.input_border_style = style.name" v-for="style in [{ name: 'Border', icon: 'border' }, { name: 'Underline', icon: 'line' }]" iconSize="30px" :key="style.name" :title="style.name" :icon="style.icon" size="xs" :active="$settings.customizer.design.input_border_style == style.name" :iconStyle="`color:${$settings.customizer.design.input_border_color} !important;`" />
                </div>
            </div>
        </Accordion>

        <div class="transition-all" :class="[activeAccordion == 'Button' ? 'mt-3' : 'my-3 h-[1px] bg-[#EAECF0]']"></div>

        <!-- button section -->
        <Accordion leftIcon="cursorBox" title="Button" :isOpen="activeAccordion == 'Button'" @click="toggleAccordion('Button')">
            <div>
                <div class="flex items-center justify-between mb-2">
                    <div class="text-[#101828] font-medium text-sm">Button Text</div>
                    <!-- <input type="color" v-model="$settings.customizer.design.button_text_color" class="w-6"> -->
                    <ColorPickerDefault v-model="$settings.customizer.design.button_text_font_color" class="w-6" />
                </div>

                <div class="grid grid-cols-3 gap-3">
                    <OptionButton @click="$settings.customizer.design.button_text_font_weight = style.name" v-for="style in [{ name: 'Medium', class: '!font-medium m-auto' }, { name: 'SemiBold', class: '!font-semibold m-auto' }, { name: 'Bold', class: '!font-bold m-auto' }]" :key="style.name" :title="style.name" :icon="style.icon" size="sm" :textClass="style.class" :active="$settings.customizer.design.button_text_font_weight == style.name" />
                </div>
            </div>

            <div>
                <div class="flex items-center justify-between mb-2">
                    <div class="text-[#101828] font-medium text-sm">Button Background</div>
                    <!-- <input type="color" v-model="$settings.customizer.design.button_background_color" class="w-6"> -->
                    <ColorPickerDefault v-model="$settings.customizer.design.button_background_color" class="w-6" />
                </div>

                <div class="grid grid-cols-2 gap-3 mt-2 mb-[16px]">
                    <OptionButton @click="$settings.customizer.design.button_background_style = style.name" v-for="style in [{ name: 'Filled', icon: 'filled' }, { name: 'Border', icon: 'border' }]" :key="style.name" :title="style.name" :icon="style.icon" size="md" :active="$settings.customizer.design.button_background_style == style.name" :iconStyle="`color:${$settings.customizer.design.button_background_color} !important;`" />
                </div>
            </div>

            <div>
                <div class="text-[#101828] font-medium text-sm mb-2">Rounded Corner (PX)</div>

                <Input type="number" v-model="$settings.customizer.design.button_border_radius" :min="0" :max="100" iconLeft="minus" iconRight="plus" @iconLeftClick="$settings.customizer.design.button_border_radius--" @iconRightClick="$settings.customizer.design.button_border_radius++" inputClass="text-center !w-[calc(100%-64px)]" inputContainerClass="!px-3 !h-12" iconLeftClass="text-[#344054] hover:bg-[#F2F4F7] rounded-full p-1 !w-8 !h-auto cursor-pointer" iconRightClass="text-[#344054] hover:bg-[#F2F4F7] rounded-full p-1 !w-8 !h-auto cursor-pointer"></Input>
            </div>
        </Accordion>
    </div>
</template>


<style>

</style>